export default __webpack_public_path__ + "static/media/pic1.a2840aa7.jpg";